export const PricingConstant = {
    PRICE_PER_REPORT: 249,
    RENEW_PRICE: 99,
    PRICE_PER_YEAR: 749
}

export const PricingPlanType = {
    REPORT_PURCHASE: 'report-purchase',
    PROFESSIONAL_PLAN: 'professional-plan',
    ENTERPRISE_PLAN: 'enterprise-plan'
}
